module.exports = __webpack_public_path__ + "static/img/tu6-m.8322cdbe.png";